import * as actionTypes from '../actions'

const initialState = {
    show: false,
    shippingInfo: [],
    totalAmount: 0,
    taxAmountTotal: 0,
    consumptionTaxAmountTotal: 0,
    active: false,
    loading: false,
    summaryModal: false,
    firstName: '',
    lastName: '',
    documentId: '',
    documentIdNomenclature: '',
    email: '',
    phone: '',
    nomenclature: '',
    address1: '',
    address2: '',
    address3: '',
    complement: '',
    country: 'CO',
    countryName: 'Colombia',
    countryCode: "57",
    city: '',
    departament: '',
    codeDane: '',
    channel: '',
    customShippingValue: '',
    customShippingStatus: true,
    shippingValue: '',
    paymentMethod: '',
    saveInfoClient: false,
    infoCompleted: false,
    discountCodes: [],
    paymentMethodBoolean: false,
    streetType: '',
    streetName: '',
    streetNumber: '',
    crossNumber: '',
    housingType: '',
    locationDetail: '',
    additionalAddress: '',
    isAveonline: false,

}

const shippingDetailsReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case actionTypes.LOADING_DETAILS: {
            return {
                ...state,
                loading: action.payload
            }
        }


        case actionTypes.RESET_DETAILS: {
            return {
                ...state,
                firstName: '',
                lastName: '',
                documentId: '',
                email: '',
                phone: '',
                address1: '',
                address2: '',
                address3: '',
                country: 'CO',
                countryName: 'Colombia',
                countryCode: "57",
                city: '',
                departament: '',
                streetType: '',
                streetName: '',
                streetNumber: '',
                crossNumber: '',
                housingType: '',
                locationDetail: '',
                additionalAddress: '',
                isAveonline: false,
            }

        }
        case actionTypes.SHOW_DETAILS: {
            return {
                ...state,
                show: true,
                active: true
            }
        }
        case actionTypes.HIDE_DETAILS: {
            return {
                ...state,
                show: false,
            }
        }

        case actionTypes.DETAILS_ERROR: {
            return {
                ...state,
                show: false,
            };
        }

        case actionTypes.SHOW_SUMMARY_MODAL: {
            return {
                ...state,
                summaryModal: true
            };
        }

        case actionTypes.HIDE_SUMMARY_MODAL: {
            return {
                ...state,
                summaryModal: false
            };
        }
        case actionTypes.FORM_FIRST_NAME: {
            return {
                ...state,
                firstName: action.payload
            }
        }
        case actionTypes.FORM_LAST_NAME: {
            return {
                ...state,
                lastName: action.payload
            }
        }
        case actionTypes.FORM_DOCUMENT_ID: {
            return {
                ...state,
                documentId: action.payload
            }
        }
        case actionTypes.FORM_DOCUMENT_ID_NOMENCLATURE: {
            return {
                ...state,
                documentIdNomenclature: action.payload
            }
        }
        case actionTypes.FORM_EMAIL: {
            return {
                ...state,
                email: action.payload
            }
        }
        case actionTypes.FORM_PHONE: {
            return {
                ...state,
                phone: action.payload
            }
        }
        case actionTypes.FORM_NOMENCLATURE: {
            return {
                ...state,
                nomenclature: action.payload
            }
        }
        case actionTypes.FORM_ADRESS1: {
            return {
                ...state,
                address1: action.payload
            }
        }
        case actionTypes.FORM_ADRESS2: {
            return {
                ...state,
                address2: action.payload
            }
        }
        case actionTypes.FORM_ADRESS3: {
            return {
                ...state,
                address3: action.payload
            }
        }
        case actionTypes.FORM_COMPLEMENT: {
            return {
                ...state,
                complement: action.payload
            }
        }
        case actionTypes.FORM_CITY: {
            return {
                ...state,
                city: action.payload
            }
        }
        case actionTypes.CUSTOM_SHIPPING_VALUE: {
            return {
                ...state,
                customShippingValue: action.payload
            }
        }
        case actionTypes.CUSTOM_SHIPPING_STATUS: {
            return {
                ...state,
                customShippingStatus: action.payload
            }
        }

        case actionTypes.SHIPPING_VALUE: {
            return {
                ...state,
                shippingValue: action.payload
            }
        }

        case actionTypes.PAYMENT_METHOD: {
            return {
                ...state,
                paymentMethod: action.payload
            }
        }
        case actionTypes.PAYMENT_METHOD_BOOLEAN: {
            return {
                ...state,
                paymentMethodBoolean: action.payload
            }
        }
        case actionTypes.LOAD_DETAILS: {
            return {
                ...state,
                ...action.payload
            }
        }
        case actionTypes.SEARCH_BUYER: {
            return {
                ...state,
                ...action.payload
            }
        }

        default: {
            return state
        }
    }
}

export default shippingDetailsReducer
